<template>
  <section>
    <template v-if="partner">
      <div class="container content-padding">
        <div class="row">
          <div class="col-12">
            <h2>Partner: {{ partner.name }}</h2>
            <div>
              <h4>เรียงข้อมูลตาม:</h4>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="sortBy" id="order_date" value="order_date" v-model="queryData.sort_by" @change="getOrderReport()">
              <label class="form-check-label" for="order_date">วันที่ทำการจอง</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="sortBy" id="cleaning_date" value="cleaning_date" v-model="queryData.sort_by" @change="getOrderReport()">
              <label class="form-check-label" for="cleaning_date">วันที่เข้าให้บริการ</label>
            </div>
            <div class="mt-3">
              <h4>เรียงข้อมูลจาก:</h4>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="sortOrder" id="asc" value="asc" v-model="queryData.sort_order" @change="getOrderReport()">
              <label class="form-check-label" for="asc">น้อยไปมาก</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="sortOrder" id="desc" value="desc" v-model="queryData.sort_order" @change="getOrderReport()">
              <label class="form-check-label" for="desc">มากไปน้อย</label>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-4 col-sm-6">
            <div>
              <h4>วันที่เริ่มต้น:</h4>
            </div>
            <div class="form-group">
              <input type="text"
                     placeholder="เริ่มต้น"
                     class="form-control -date-picker input-jumbo"
                     v-pikadayReport="start"
                     @change="updateDate('start_date', $event)"
                     ref="start"
                     readonly>
            </div>
          </div>
          <div class="col-md-4 col-sm-6">
            <div>
              <h4>วันที่สิ้นสุด:</h4>
            </div>
            <div class="form-group">
              <input type="text"
                     placeholder="สิ้นสุด"
                     class="form-control -date-picker input-jumbo"
                     v-pikadayReport="end"
                     @change="updateDate('end_date', $event)"
                     ref="end"
                     readonly>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-12">
            <button class="btn btn-primary" @click.prevent="openModal()">แนวโน้มยอดจองรายเดือน</button>
          </div>
        </div>
        <div class="row mt-3" v-if="orders && orders.length">
          <div class="col-12 table-responsive">
            <table class="table table-striped" style="font-size: 80%;">
              <thead>
              <tr>
                <th>#</th>
                <th class="text-center">วันที่ทำการจอง</th>
                <th class="text-center">วันที่ใช้บริการ</th>
                <th class="text-center">รหัสงาน</th>
                <th>Reference</th>
                <th class="text-right">ค่าบริการหลังส่วนลด</th>
                <th>ชื่อลูกค้า</th>
                <th v-if="partner.report_type_id !== 2">ที่อยู่ใช้บริการ</th>
                <th class="text-center">สถานะ</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(order, index) in orders" :key="order.id">
                <td>{{ index + 1 }}</td>
                <td class="text-center">{{ order.created_at }}</td>
                <td class="text-center">{{ order.service_date }}</td>
                <td class="text-center">#{{ order.code }}</td>
                <td>{{ order.reference }}</td>
                <td class="text-right">{{ order.amount | currency }}</td>
                <td>{{ order.name }}</td>
                <td v-if="partner.report_type_id !== 2">{{ order.address }}</td>
                <td class="text-center">{{ order.booking_status }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </template>
    <sweet-modal ref="modal" overlay-theme="dark" width="none">
      <div class="row text-left">
        <div class="col-xl-4 col-md-6">
          <label>เลือกปี</label>
          <select class="form-control" v-model="trendQueryData.year" @change="getOrderTrend()">
            <option v-for="year in years" :value="year" :key="year">{{ year }}</option>
          </select>
        </div>
      </div>
      <div class="row text-left mt-3">
        <div class="col-12">
          <div>
            <h4>นับวันที่จาก:</h4>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" name="dateField" id="trend_order_date" value="order_date" v-model="trendQueryData.date_field" @change="getOrderTrend()">
            <label class="form-check-label" for="trend_order_date">วันที่ทำการจอง</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" name="dateField" id="trend_cleaning_date" value="cleaning_date" v-model="trendQueryData.date_field" @change="getOrderTrend()">
            <label class="form-check-label" for="trend_cleaning_date">วันที่เข้าให้บริการ</label>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <canvas id="chart"></canvas>
        </div>
      </div>
    </sweet-modal>
  </section>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import { Chart } from 'chart.js'
import { mapState } from 'vuex'
import { SweetModal } from 'sweet-modal-vue'
import BookingGrabReport from './BookingGrabReport'

export default {
  data () {
    return {
      partnerId: null,
      username: '',
      password: '',
      loginButtonText: 'LOGIN',
      queryData: {
        sort_by: 'order_date',
        sort_order: 'asc',
        start_date: '',
        end_date: ''
      },
      trendQueryData: {
        date_field: 'order_date',
        year: moment().year()
      },
      orders: [],
      start: null,
      end: null,
      loading: false,
      chart: null
    }
  },
  components: {
    BookingGrabReport,
    SweetModal
  },
  computed: {
    ...mapState({
      token: state => state.authPartner.token,
      partner: state => state.authPartner.partner
    }),
    years () {
      let start = 2020
      let end = moment().year() + 1
      return Array(end - start).fill().map((d, i) => i + start)
    }
  },
  methods: {
    updateDate (attribute, e) {
      const date = moment(e.target.value, 'DD/MM/yyyy').format('yyyy-MM-DD')
      this.queryData[attribute] = date
      this.getOrderReport()
    },
    openModal () {
      this.getOrderTrend()
      this.$refs.modal.open()
    },
    closeModal () {
      this.$refs.modal.close()
    },
    createChart (data) {
      const ctx = document.getElementById('chart')
      if (this.chart && this.chart.data) {
        this.chart.data.labels = data.labels
        this.chart.data.datasets = data.datasets
        this.chart.update()
      } else {
        this.chart = new Chart(ctx, {
          type: 'bar',
          data: {
            labels: data.labels,
            datasets: data.datasets
          },
          options: {
            responsive: true,
            tooltips: {
              displayColors: false
            },
            legend: {
              display: false
            }
          }
        })
      }
    },
    async initData () {
      this.start = moment().startOf('month').format('DD/MM/yyyy')
      this.end = moment().endOf('month').format('DD/MM/yyyy')
      this.queryData.start_date = moment().startOf('month').format('yyyy-MM-DD')
      this.queryData.end_date = moment().endOf('month').format('yyyy-MM-DD')
    },
    async getOrderReport () {
      const headers = { 'Authorization': `Bearer ${this.token}` }
      const params = { ...this.queryData }
      const { data } = await axios.get('partners/orders/reports', { headers, params })
      if (!data.error) {
        this.orders = data.orders
      }
    },
    async getOrderTrend () {
      const headers = { 'Authorization': `Bearer ${this.token}` }
      const params = { ...this.trendQueryData }
      const { data } = await axios.get('partners/orders/trend', { headers, params })
      if (!data.error && data.data) {
        this.createChart(data.data)
      }
    }
  },
  created () {
    if (this.$route.params.id) {
      this.partnerId = Number(this.$route.params.id)
    }
    if (this.token) {
      this.loading = true
      this.initData()
      this.getOrderReport()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/partner/BookingReport.vue